// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"230":"component---src-pages-index-jsx","532":"styles"}[chunkId] + "-" + {"230":"917177751c75e652ae18","532":"6ce31cf20507fe7e654e"}[chunkId] + ".js";
};